import { Dialog } from 'construct-ui';
import { v4 as uuidv4 } from 'uuid';
import SingleSelectCommonComponentView from '../../../../components/common/single-select-common-component.view';
import { messageComponent } from '../../../../components/message/message.component';
import loginModel from '../../../../models/login.model';
import taskMasterModel from '../../../../models/task-management/task-master.model';
import ViewBase from '../../../view-base.view';
import TaskMasterRadioListView from './task-master-radio-list.view';
import TaskMasterLinkView from './task-master-select-link.view';

export default function TaskMasterAddView() {
  ViewBase.call(this);

  let onAddClose = (e) => { };
  let onSaveComplete = (e) => { };

  let canEdit = true;
  let isLoading = false;
  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";
  let isMenuListViewOpen = false;
  let isYesMenuListViewOpen = false;
  let isNoMenuListViewOpen = false;

  let inputDatModel = {
    ddlActionType: { code: "", name: "" },
    ddlStatus: { code: "", name: "" },
    ddlYesActionType: { code: "", name: "" },
    ddlNoActionType: { code: "", name: "" },
    taskName: "",
    description: "",
    masterId: 0,
    permission: "",
    actionTypeList: [],
    selectedActionType: "",
    statusList: [],
    selectedStatus: "",
    selectedMenu: "",
    radioList: [],
    selectedYesActionType: "",
    categoryList: [],
    ddlCategory: { code: "", name: "" },
    selectedCategory: "",
    selectedNoActionType: "",
    selectedYesRadioList: [],
    selectedNoRadioList: [],
    yesType: "",
    noType: "",
    yesNoActionTypeList: [],
    selectedYesMenu: "",
    selectedNoMenu: "",
    menuParameter: "",
    yesMenuParameter: "",
    noMenuParameter: "",
    taskYesActionID: "",
    taskNoActionID: "",
    actionType: ""
  };

  let _isTaskCategoryEditable = () => inputDatModel.categoryList.length > 2;

  let _getTaskName = (e) => {
    inputDatModel.taskName = e.target.value;
  }

  let _getParameterName = (e) => {
    inputDatModel.menuParameter = e.target.value;
  }

  let _getYesParameterName = (e) => {
    inputDatModel.yesMenuParameter = e.target.value;
  }

  let _getNoParameterName = (e) => {
    inputDatModel.noMenuParameter = e.target.value;
  }

  let _getDescription = (e) => {
    inputDatModel.description = e.target.value;
  }

  let _loadTaskCategoryList = () => {
    this.showLoading();
    taskMasterModel.getTaskCategories()
      .then(r => {
        if (r && Array.isArray(r) && r.length > 0) {
          inputDatModel.categoryList = [{ code: "", name: this.getText("LT00000010", "Choose...") }, ...r];
        }
      }).catch(e => {
        this.handleError(e)
      }).finally(() => {
        this.hideLoading();
      })
  }

  let _loadActionTypeList = (masterId, userId) => {
    if (masterId) {
      inputDatModel.masterId = Number(masterId);
    }
    // isLoading = true;
    inputDatModel.actionTypeList = [];
    taskMasterModel.getActionTypeList(
      (result) => {
        isLoading = false;
        inputDatModel.actionTypeList.push({ code: "", name: this.getText("LT00000010", "Choose...") });
        if (result && result.length > 0) {
          result.forEach(function (item) {
            inputDatModel.actionTypeList.push({ code: item.code, name: item.name });
          });
        }

        inputDatModel.yesNoActionTypeList.push({ code: "", name: this.getText("LT00000010", "Choose...") });
        if (result && result.length > 0) {
          result.forEach(function (item) {
            if (item.code === "002" || item.code === "003")
              inputDatModel.yesNoActionTypeList.push({ code: item.code, name: item.name });
          });
        }
        inputDatModel.ddlYesActionType = { code: "", name: "" };
        inputDatModel.ddlNoActionType = { code: "", name: "" };
        if (masterId && inputDatModel.masterId > 0) {
          _loadDataForId(userId);
        }
      },
      (error) => {
        // isLoading = false;
        this.handleError(error);
      }
    )
  }

  let _getRadioItemsWithSequence = (id) => {
    let items = document.querySelectorAll('#' + id + '> li');
    let seq = 1;
    let dtValues = [];
    items.forEach(item => {
      let inputList = item.querySelectorAll('input')
      let radioValues = { name: "", sequence: "" };
      let txtValue = inputList[0].value;
      let txtId = inputList[1].value;
      radioValues["name"] = txtValue;
      radioValues["sequence"] = seq.toString();
      if (inputDatModel.masterId > 0) {
        radioValues["taskListItemID"] = txtId;
      }

      dtValues.push(radioValues);
      seq++;

    });
    return dtValues;
  }

  let _generateSaveObject = (dataModel) => {
    dataModel.taskMstId = inputDatModel.masterId;
    dataModel.taskName = inputDatModel.taskName;
    dataModel.description = inputDatModel.description;
    dataModel.permission = inputDatModel.permission;
    dataModel.actionType = inputDatModel.selectedActionType;
    dataModel.status = inputDatModel.selectedStatus;
    dataModel.category = inputDatModel.selectedCategory;
    if (dataModel.taskName === "") {
      dataModel.error = this.getText("EM00000221", "Please enter task name");
      return dataModel;
    }
    if (dataModel.description === "") {
      dataModel.error = this.getText("EM00000222", "Please enter task description");
      return dataModel;
    }
    if (dataModel.permission === "") {
      dataModel.error = this.getText("EM00000223", "Please select permission level");
      return dataModel;
    }
    if (_isTaskCategoryEditable() && dataModel.category === "") {
      dataModel.error = this.getText("EM00000822", "Please enter task category");
      return dataModel;
    }
    if (dataModel.actionType === "002")//Link
    {
      if (inputDatModel.selectedMenu != "") {
        dataModel.menuID = inputDatModel.selectedMenu["menuID"];
        dataModel.menuLinkParameter = inputDatModel.menuParameter;
      }
      else {
        dataModel.error = this.getText("EM00000217", "Please select a menu from the list");
        return dataModel;
      }

    }
    else if (dataModel.actionType === "003") {//RaDIO
      if (inputDatModel.radioList.length > 0) {
        let empLst = inputDatModel.radioList.filter(x => x.name === '');
        if (empLst.length === 0) {
          if (inputDatModel.masterId > 0) {
            dataModel["radioItem"] = inputDatModel.radioList;
          }
          else {
            dataModel.radioItems = inputDatModel.radioList;
          }

        } else {
          dataModel.error = this.getText("EM00000220", "Radio option cannot be empty");
          return dataModel;
        }

      } else {
        dataModel.error = this.getText("EM00000218", "Please add radio options");
        return dataModel;
      }
    }
    else if (dataModel.actionType === "004") {//YESNO
      if (inputDatModel.yesType !== "" && inputDatModel.noType !== "") {
        let objYes = { answerYN: "Y", actionType: "005", menuID: "", menuLinkParameter: "", radioItems: [] };
        let objNo = { answerYN: "N", actionType: "005", menuID: "", menuLinkParameter: "", radioItems: [] };
        //YES
        if (inputDatModel.masterId > 0) {
          objYes["TaskYesNoActionID"] = inputDatModel.taskYesActionID === "" ? "0" : inputDatModel.taskYesActionID;
          objNo["TaskYesNoActionID"] = inputDatModel.taskNoActionID === "" ? "0" : inputDatModel.taskNoActionID;
        }
        if (inputDatModel.yesType === "noaction") {
          dataModel.yesNoObjects.push(objYes);
        } else {

          objYes.actionType = inputDatModel.selectedYesActionType;
          if (inputDatModel.selectedYesActionType === "002") {//link
            if (inputDatModel.selectedYesMenu !== "") {
              objYes.menuID = inputDatModel.selectedYesMenu["menuID"];
              objYes.menuLinkParameter = inputDatModel.yesMenuParameter;
            }
            else {
              dataModel.error = this.getText("EM00000217", "Please select a menu from the list");
              return dataModel;
            }

          }
          else if (inputDatModel.selectedYesActionType === "003") {//Radio
            if (inputDatModel.selectedYesRadioList.length > 0) {
              let empLstYs = inputDatModel.selectedYesRadioList.filter(x => x.name == '');
              if (empLstYs.length === 0) {
                objYes.radioItems = inputDatModel.selectedYesRadioList;
              } else {
                dataModel.error = this.getText("EM00000220", "Radio option cannot be empty");
                return dataModel;
              }

            } else {
              dataModel.error = this.getText("EM00000218", "Please add radio options");
              return dataModel;
            }
          }
          else {
            dataModel.error = this.getText("EM00000219", "Please action type");
            return dataModel;
          }
          dataModel.yesNoObjects.push(objYes);
        }
        //NO
        if (inputDatModel.noType === "noaction") {
          dataModel.yesNoObjects.push(objNo);
        } else {

          objNo.actionType = inputDatModel.selectedNoActionType;
          if (inputDatModel.selectedNoActionType === "002") {//link
            if (inputDatModel.selectedNoMenu != "") {
              objNo.menuID = inputDatModel.selectedNoMenu["menuID"];
              objNo.menuLinkParameter = inputDatModel.noMenuParameter;
            }
            else {
              dataModel.error = this.getText("EM00000217", "Please select a menu from the list");
              return dataModel;
            }

          }
          else if (inputDatModel.selectedNoActionType === "003") {//Radio
            if (inputDatModel.selectedNoRadioList.length > 0) {
              let empLstNo = inputDatModel.selectedNoRadioList.filter(x => x.name == '');
              if (empLstNo.length === 0) {
                objNo.radioItems = inputDatModel.selectedNoRadioList;
              } else {
                dataModel.error = this.getText("EM00000220", "Radio option cannot be empty");
                return dataModel;
              }

            } else {
              dataModel.error = this.getText("EM00000218", "Please add radio options");
              return dataModel;
            }
          }
          else {
            dataModel.error = this.getText("EM00000219", "Please action type");
            return dataModel;
          }
          dataModel.yesNoObjects.push(objNo);
        }

      } else {
        dataModel.error = this.getText("EM00000219", "Please action type");
        return dataModel;
      }
    } else if (dataModel.actionType === "001" || dataModel.actionType === "005") {
      dataModel.error = "";
    }
    else {
      dataModel.error = this.getText("EM00000219", "Please action type");
      return dataModel;
    }

    return dataModel;
  }

  let _save = () => {
    let dataModel = { taskName: "", description: "", permission: "", actionType: "", menuID: "", menuLinkParameter: "", radioItems: [], yesNoObjects: [], error: "" };
    inputDatModel.selectedActionType = inputDatModel.ddlActionType.code;
    inputDatModel.selectedStatus = inputDatModel.ddlStatus.code;
    inputDatModel.selectedYesActionType = inputDatModel.ddlYesActionType.code;
    inputDatModel.selectedNoActionType = inputDatModel.ddlNoActionType.code;
    inputDatModel.selectedNoRadioList = _getRadioItemsWithSequence("actionRadioNo");
    inputDatModel.selectedYesRadioList = _getRadioItemsWithSequence("actionRadioYes");
    inputDatModel.radioList = _getRadioItemsWithSequence("actionRadio");
    inputDatModel.selectedCategory = inputDatModel.ddlCategory.code;
    _generateSaveObject(dataModel);
    if (dataModel.error === "") {
      if (inputDatModel.masterId > 0) {
        taskMasterModel.editTaskMaster(
          (result) => {
            if (result[0].transStatus === "SUCCESS") {
              onSaveComplete(result);
            }

          },
          (error) => {
            this.handleError(error);
          },
          dataModel
        )

      } else {
        taskMasterModel.saveTaskMaster(
          (result) => {
            if (result[0].transStatus === "SUCCESS") {
              onSaveComplete(result);
            }
          },
          (error) => {
            this.handleError(error);
          },
          dataModel
        )
      }

    } else {
      isMsgOpen = true;
      showMsg = dataModel.error;
      msgTitle = this.getText("EM00000142", "Error");
    }

  }

  let _cancel = (e) => {
    onAddClose(e);
  }

  let _dialogClosed = () => {
    isMsgOpen = false;
  }

  let _onMenuLinkSaved = (item) => {
    inputDatModel.selectedMenu = item;
    isMenuListViewOpen = false;
  }

  let _onYesMenuLinkSaved = (item) => {

    inputDatModel.selectedYesMenu = item;
    isYesMenuListViewOpen = false;
  }

  let _onNoMenuLinkSaved = (item) => {

    inputDatModel.selectedNoMenu = item;
    isNoMenuListViewOpen = false;
  }

  let _onRadioListChanged = (item) => { }

  let _onYesRadioListChanged = (item) => { }

  let _onNoRadioListChanged = (item) => { }

  let _loadDataForId = (userID) => {
    taskMasterModel.getMasterDetailById(
      (result) => {
        isLoading = false;
        _arrangeInputDataModel(result, userID);

      },
      (error) => {
        isLoading = false;
        this.handleError(error);
      },
      inputDatModel.masterId
    )
  }

  let _arrangeInputDataModel = (result, userID) => {
    if (loginModel.credentials.admin) {
      canEdit = true;
    } else {
      if (loginModel.credentials.userID === userID) {
        canEdit = true;
      } else {
        canEdit = false;
      }
    }
    inputDatModel.description = result.taskResult[0]?.description || '';
    inputDatModel.taskName = result.taskResult[0]?.taskName || '';

    inputDatModel.selectedStatus = result.taskResult[0]?.status || '';
    inputDatModel.permission = result.taskResult[0]?.permission || '';
    inputDatModel.actionType = result.taskResult[0]?.actionType || '';
    inputDatModel.ddlActionType = { code: result.taskResult[0]?.actionType || '', name: result.taskResult[0]?.actionTypeName || '' };
    inputDatModel.ddlStatus = { code: result.taskResult[0]?.status || '', name: result.taskResult[0]?.statusName || '' };
    inputDatModel.ddlCategory = { code: result.taskResult[0]?.category || '', name: result.taskResult[0]?.categoryName || '' };
    if (inputDatModel.actionType === "002") {//Link
      inputDatModel.selectedMenu = { menuID: result.taskResult[0]?.menuID || '', name: result.taskResult[0]?.menuName || '' };//need to set
      inputDatModel.menuParameter = result.taskResult[0]?.menuLinkParameter || '';
    }
    else if (inputDatModel.actionType === "003") {//Radio
      result.taskListResult.forEach(function (item) {
        inputDatModel.radioList.push({ name: item.name, sequence: item.sequence, id: uuidv4(), taskListItemID: item.taskListItemID });
      });
      inputDatModel.radioList.sort((a, b) => a.sequence - b.sequence);
    }
    else if (inputDatModel.actionType === "004") {//YESNO
      let yesObj = result.actionResult?.filter(x => x.answerYN === "Y")[0];
      let noObj = result.actionResult?.filter(x => x.answerYN === "N")[0];
      //YES
      if (yesObj) {
        inputDatModel.taskNoActionID = yesObj.taskYesNoActionID;
        inputDatModel.taskYesActionID = yesObj.taskYesNoActionID;
        if (yesObj.actionType === "005") {//no action
          inputDatModel.yesType = "noaction";
        }
        else {
          inputDatModel.yesType = "action";
          inputDatModel.selectedYesActionType = yesObj.actionType;
          let itmArr = inputDatModel.yesNoActionTypeList.filter(x => x.code === yesObj.actionType);
          inputDatModel.ddlYesActionType = { code: yesObj.actionType === null ? "" : yesObj.actionType, name: itmArr[0]?.name || '' };
          if (yesObj.actionType === "002") {//menu
            inputDatModel.yesMenuParameter = yesObj.menuLinkParameter;
            inputDatModel.selectedYesMenu = { menuID: yesObj.menuID, name: yesObj.menuName };
          }
          else {
            inputDatModel.yesType = "action";
            let mArr = yesObj.radioItems.split('|');
            mArr.forEach(function (item) {
              let msArr = item.split('^');
              inputDatModel.selectedYesRadioList.push({ name: msArr[0], sequence: msArr[1], id: uuidv4(), taskListItemID: msArr[2] });
            });
            inputDatModel.selectedYesRadioList.sort((a, b) => a.sequence - b.sequence);
          }
        }
      }
      //NO
      if (noObj) {
        if (noObj.actionType === "005") {//noaction
          inputDatModel.noType = "noaction";
        }
        else {
          inputDatModel.noType = "action";
          let itmArr = inputDatModel.yesNoActionTypeList.filter(x => x.code === noObj.actionType);
          inputDatModel.ddlNoActionType = { code: noObj.actionType, name: itmArr[0]?.name || '' };
          inputDatModel.selectedNoActionType = noObj.actionType;

          if (noObj.actionType === "002") {//menu
            inputDatModel.noMenuParameter = noObj.menuLinkParameter;
            inputDatModel.selectedNoMenu = { menuID: noObj.menuID, name: noObj.menuName };
          }
          else {
            inputDatModel.noType = "action";
            let mArr = noObj.radioItems.split('|');
            mArr.forEach(function (item) {
              let msArr = item.split('^');
              inputDatModel.selectedNoRadioList.push({ name: msArr[0], sequence: msArr[1], id: uuidv4(), taskListItemID: msArr[2] });
            });
            inputDatModel.selectedNoRadioList.sort((a, b) => a.sequence - b.sequence);

          }
        }
      }
    }
  }

  const renderYESActionType = () => {
    const getActionComponent = (code) => {
      switch (code) {
        case "002":
          return m('.col-md-12.mt-4', //LINK
            m('.card', m('.card-body',
              m('.d-flex.justify-content-between',
                m('label.form-label', this.getText("LT00000087", "Link"),
                  m('span.redText', "*")),
                m('button.btn.btn-sm.btn-primary', {
                  disabled: !canEdit,
                  onclick: () => {
                    isYesMenuListViewOpen = true;
                  }
                },
                  this.getText("LT00000086", "Please Specify Menu")
                ),
              ),

              inputDatModel.selectedYesMenu && m('.row.mt-2',
                m('.col-md-12.mt-2',
                  m('label.selectedMenu',
                    inputDatModel.selectedYesMenu["name"] || "")),
                m('.col-md-12', m('input[type="text"][placeholder="' + this.getText("LT00000093", "Url Parameters") + '"][value="' + inputDatModel.yesMenuParameter + '"].form-control.form-control-bg', { disabled: !canEdit, onchange: _getYesParameterName }))
              )
            ))
          );
        case "003":
          return m('.col-md-12.mt-4', //RADIO
            m(TaskMasterRadioListView, {
              onChanged: _onYesRadioListChanged,
              radioList: inputDatModel.selectedYesRadioList,
              id: "actionRadioYes",
              canEdit: canEdit
            }));
        default:
          return null;
      }
    };

    return m('.card',
      m('.card-body',
        m('.col-md-12',
          m('.col-md-6', m('label.form-label', this.getText("LT00000080", "Action Type")),
            m(SingleSelectCommonComponentView, {
              disabled: !canEdit, iconList: [],
              items: inputDatModel.yesNoActionTypeList,
              selectedItem: inputDatModel.ddlYesActionType,
              handleSelect: (selectedItem) => {
                inputDatModel.ddlYesActionType = selectedItem;
                inputDatModel.selectedMenu = "";
                inputDatModel.radioList = [];
                inputDatModel.selectedYesActionType = "";
                inputDatModel.selectedYesRadioList = [];
                inputDatModel.selectedYesMenu = "";
              }
            }),
          ),
          getActionComponent(inputDatModel.ddlYesActionType.code)
        ),
      ))
  }

  const renderActionTypeOption = () => {
    if (inputDatModel.ddlActionType.code === "001") {
      return null;
    } else {
      if (inputDatModel.ddlActionType.code === "002") {
        return m('.col-md-12.mt-4', //LINK
          m('.card', m('.card-body',
            m('.d-flex.justify-content-between',
              m('label.form-label', this.getText("LT00000087", "Link"),
                m('span.redText', "*")),
              m('button.btn.btn-sm.btn-primary', {
                disabled: !canEdit,
                onclick: () => {
                  isMenuListViewOpen = true;
                }
              },
                this.getText("LT00000086", "Please Specify Menu")
              ),
            ),

            m('.col-md-12.mt-2',
              m('.col-md-12.mt-2', m('label.selectedMenu', inputDatModel.selectedMenu != null ? inputDatModel.selectedMenu["name"] : "")),
              inputDatModel.selectedMenu != "" && m('.col-md-12',
                m('input[type="text"].form-control.form-control-bg', {
                  placeholder: this.getText("LT00000093", "Url Parameters"),
                  disabled: !canEdit,
                  value: inputDatModel.menuParameter,
                  onchange: _getParameterName
                }))
            )
          ))
        )
      } else if (inputDatModel.ddlActionType.code === "003") {
        return m('.col-md-12.mt-4',//RADIO
          m(TaskMasterRadioListView, { onChanged: _onRadioListChanged, radioList: inputDatModel.radioList, id: "actionRadio", canEdit: canEdit })
        )
      } else if (inputDatModel.ddlActionType.code === "004") {
        return m('.col-md-12.mt-4', //yesno
          m('.card', m('.card-body',
            m('.col-md-12',
              m('.col-md-12',
                m('.col-md-12', m('label', this.getText("LT00000023", "Yes"))),
                m('.row',
                  m('.col-md-6',
                    m('.form-check.form-check-inline',
                      m('input.form-check-input[type="radio"][name="radioTypeYes"]',
                        {
                          checked: inputDatModel.yesType === "noaction",
                          disabled: !canEdit,
                          onclick: (e) => {
                            inputDatModel.selectedMenu = "";
                            inputDatModel.radioList = [];
                            inputDatModel.selectedYesActionType = "";
                            inputDatModel.selectedYesRadioList = [];
                            inputDatModel.selectedYesMenu = "";
                            inputDatModel.ddlYesActionType = { code: "", name: "" };
                            inputDatModel.yesType = "noaction";
                          }
                        }
                      ),
                      m('label.form-check-label', this.getText("LT00000091", "No Action"))
                    )
                  ),
                  m('.col-md-6',
                    m('.form-check.form-check-inline',
                      m('input.form-check-input[type="radio"][name="radioTypeYes"]',
                        {
                          checked: inputDatModel.yesType === "action",
                          disabled: !canEdit,
                          onclick: (e) => {
                            inputDatModel.selectedMenu = "";
                            inputDatModel.radioList = [];
                            inputDatModel.selectedYesActionType = "";
                            inputDatModel.selectedYesRadioList = [];
                            inputDatModel.selectedYesMenu = "";
                            inputDatModel.ddlYesActionType = { code: "", name: "" };
                            inputDatModel.yesType = "action";
                          }
                        }
                      ),
                      m('label.form-check-label', this.getText("LT00000092", "Action"))
                    )
                  ),
                ),

              ),

              inputDatModel.yesType === "action" && renderYESActionType(),

              m('.col-md-12',
                m('.col-md-12', m('label', this.getText("LT00000024", "No"))),
                m('.row',
                  m('.col-md-6',
                    m('.form-check.form-check-inline',
                      m('input.form-check-input[type="radio"][name="radioTypeNo"]',
                        {
                          checked: inputDatModel.noType === "noaction",
                          disabled: !canEdit,
                          onclick: (e) => {
                            inputDatModel.selectedMenu = "";
                            inputDatModel.radioList = [];
                            inputDatModel.selectedNoRadioList = [];
                            inputDatModel.selectedNoMenu = "";
                            inputDatModel.ddlNoActionType = { code: "", name: "" };
                            inputDatModel.noType = "noaction"
                          }
                        }
                      ),
                      m('label.form-check-label', this.getText("LT00000091", "No Action"))
                    )
                  ),
                  m('.col-md-6',
                    m('.form-check.form-check-inline',
                      m('input.form-check-input[type="radio"][name="radioTypeNo"]',
                        {
                          checked: inputDatModel.noType === "action",
                          disabled: !canEdit,
                          onclick: (e) => {
                            inputDatModel.selectedMenu = "";
                            inputDatModel.radioList = [];
                            inputDatModel.selectedNoRadioList = [];
                            inputDatModel.selectedNoMenu = "";
                            inputDatModel.ddlNoActionType = { code: "", name: "" };
                            inputDatModel.noType = "action"
                          }
                        }
                      ),
                      m('label.form-check-label', this.getText("LT00000092", "Action"))
                    )
                  ),
                ),

              ),
              inputDatModel.noType === "action" && m('.card', m('.card-body',
                m('.col-md-12',
                  m('.col-md-4', m('label.form-label', this.getText("LT00000080", "Action Type")),
                    m(SingleSelectCommonComponentView, {
                      disabled: !canEdit, iconList: [], items: inputDatModel.yesNoActionTypeList, selectedItem: inputDatModel.ddlNoActionType, handleSelect: (selectedItem) => {
                        inputDatModel.ddlNoActionType = selectedItem;
                        inputDatModel.selectedMenu = "";
                        inputDatModel.radioList = [];
                        inputDatModel.selectedNoActionType = "";
                        inputDatModel.selectedNoRadioList = [];
                      }
                    }),
                  ),
                  inputDatModel.ddlYesActionType.code !== "001" && (
                    inputDatModel.ddlNoActionType.code === "002" && m('.col-md-12.mt-4',//LINK
                      m('.card', m('.card-body',

                        m('.d-flex.justify-content-between',
                          m('label.form-label', this.getText("LT00000087", "Link"),
                            m('span.redText', "*")),
                          m('button.btn.btn-sm.btn-primary', {
                            disabled: !canEdit,
                            onclick: () => {
                              isNoMenuListViewOpen = true;
                            }
                          },
                            this.getText("LT00000086", "Please Specify Menu")
                          ),
                        ),
                        inputDatModel.selectedNoMenu && m('.row.mt-2',
                          m('.col-md-12.mt-2', m('label.selectedMenu', inputDatModel.selectedNoMenu["name"] || "")),
                          m('.col-md-12',
                            m('input[type="text"][placeholder="' + this.getText("LT00000093", "Url Parameters") + '"][value="' + inputDatModel.noMenuParameter + '"].form-control.form-control-bg',
                              {
                                disabled: !canEdit, onchange: _getNoParameterName
                              })
                          )
                        )
                      ))
                    ),
                    inputDatModel.ddlNoActionType.code === "003" && m('.col-md-12.mt-4',//RADIO
                      m(TaskMasterRadioListView, { onChanged: _onNoRadioListChanged, radioList: inputDatModel.selectedNoRadioList, id: "actionRadioNo", canEdit: canEdit })
                    )
                  )
                ),
              )),
            ),
            inputDatModel?.selectedMenu && m('.col-md-12',
              m('.col-md-3.mt-2', m('label.selectedMenu', inputDatModel.selectedMenu ? inputDatModel.selectedMenu["name"] : "")))
          ))
        )
      }
    }
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onAddClose) {
        onAddClose = vnode.attrs.onAddClose;
      }
      if (vnode.attrs.onSaveComplete) {
        onSaveComplete = vnode.attrs.onSaveComplete;
      }
      _loadActionTypeList(vnode.attrs.masterId, vnode.attrs.userID);
      _loadTaskCategoryList();
      inputDatModel.statusList = [{ code: "", name: "Choose..." }, { code: "001", name: "Active" }, { code: "002", name: "Inactive" }];
    },
    view: (vnode) => {
      return [
        m('.row',
          m('.col-md-12',
            m('.col-md-12', m('label.form-label', this.getText("LT00000078", "Task Name"),
              m('span.redText', "*")), m('input[type=text][placeholder=' + this.getText("LT00000078", "Task Name") + '][value="' + inputDatModel.taskName + '"].form-control.form-control-bg', { disabled: !canEdit, onchange: _getTaskName }
              )),
            _isTaskCategoryEditable() &&
            m(".col-md-12.mt-3",
              m('label.form-label', this.getText("LT00000366", "Category"), m('span.redText', "*")),
              m(SingleSelectCommonComponentView, {
                disabled: !canEdit, iconList: [], items: inputDatModel.categoryList, selectedItem: inputDatModel.ddlCategory, handleSelect: (selectedItem) => {
                  inputDatModel.ddlCategory = selectedItem;
                }
              }
              )),
            m('.col-md-12.mt-3', m('label.form-label',
              this.getText("LT00000012", "Description"),
              m('span.redText', "*")),
              m('textarea[id="txtContent"][placeholder=' + this.getText("LT00000012", "Description") + '].form-control.form-control-bg', { disabled: !canEdit, onchange: _getDescription }, inputDatModel.description
              )
            ),
            m('.row.mt-3',
              m('.col-md-12', m('label', this.getText("LT00000079", "Permission"))),
              m('.row.mt-2',
                m('.col-md-4',
                  m('.form-check.form-check-inline',
                    m('input.form-check-input[type="radio"][name="radioType"]',
                      {
                        disabled: !loginModel.credentials.admin,
                        checked: inputDatModel.permission === "001",
                        onclick: (e) => {
                          inputDatModel.permission = "001"
                        }
                      }
                    ),
                    m('label.form-check-label', this.getText("LT00000083", "Public"))
                  )
                ),
                m('.col-md-4',
                  m('.form-check.form-check-inline',
                    m('input.form-check-input[type="radio"][name="radioType"]',
                      {
                        disabled: !canEdit,
                        checked: inputDatModel.permission === "002",
                        onclick: (e) => {
                          inputDatModel.permission = "002"
                        }
                      }
                    ),
                    m('label.form-check-label', this.getText("LT00000084", "Personal"))
                  )
                ),
              ),
            ),
            inputDatModel.masterId > 0 && m('.col-md-12.mt-3', m('label.form-label', this.getText("LT00000015", "Status")),
              m(SingleSelectCommonComponentView, {
                disabled: false, iconList: [],
                items: inputDatModel.statusList,
                selectedItem: inputDatModel.ddlStatus,
                handleSelect: (selectedItem) => {
                  inputDatModel.ddlStatus = selectedItem;
                }
              }),
            ),
            //ACTION TYPE SECTION
            m('.col-md-12.mt-3', m('label.form-label', this.getText("LT00000080", "Action Type")),
              m(SingleSelectCommonComponentView, {
                disabled: !canEdit, iconList: [],
                items: inputDatModel.actionTypeList,
                selectedItem: inputDatModel.ddlActionType,
                handleSelect: (selectedItem) => {
                  inputDatModel.ddlActionType = selectedItem;
                  inputDatModel.selectedActionType = "";
                  inputDatModel.selectedMenu = "";
                  inputDatModel.radioList = [];
                  inputDatModel.selectedYesActionType = "";
                  inputDatModel.selectedNoActionType = "";
                  inputDatModel.selectedYesRadioList = [];
                  inputDatModel.selectedNoRadioList = [];
                  inputDatModel.yesType = "";
                  inputDatModel.noType = "";
                  inputDatModel.selectedYesMenu = "";
                  inputDatModel.selectedNoMenu = "";
                  inputDatModel.menuParameter = "";
                  inputDatModel.ddlYesActionType = { code: "", name: "" };
                  inputDatModel.ddlNoActionType = { code: "", name: "" };
                }
              }),
            ),
            renderActionTypeOption()
          ),
          m('.card-footer.mt-3',
            m('.col-md-12 .gap-2 .d-flex .justify-content-center',
              canEdit && m(
                "button.btn.btn-primary[type='button']", { onclick: _save },
                this.getText("LT00000022", "Save")
              ),
              m(
                "button.btn.btn-white[type='button']", { onclick: _cancel },
                this.getText("LT00000021", "Close")
              )
            )
          )
        ),
        m(Dialog, { //MainLINK
          isOpen: isMenuListViewOpen,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: () => { isMenuListViewOpen = false; },
          title: this.getText("LT00000088", "Select Link"),
          content: m(TaskMasterLinkView, { onSaved: _onMenuLinkSaved, onClosed: () => { isMenuListViewOpen = false; }, selectedMenu: inputDatModel.selectedMenu }),
          // "class": "cui-dialog-xxl"
        }),
        m(Dialog, { //YESNO  YES Link
          isOpen: isYesMenuListViewOpen,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: () => { isMenuListViewOpen = false; },
          title: this.getText("LT00000088", "Select Link"),
          content: m(TaskMasterLinkView, { onSaved: _onYesMenuLinkSaved, onClosed: () => { isYesMenuListViewOpen = false; }, selectedMenu: inputDatModel.selectedYesMenu }),
          // "class": "cui-dialog-xxl"
        }),
        m(Dialog, { //YESNO NO Link
          isOpen: isNoMenuListViewOpen,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: () => { isNoMenuListViewOpen = false; },
          title: this.getText("LT00000088", "Select Link"),
          content: m(TaskMasterLinkView, { onSaved: _onNoMenuLinkSaved, onClosed: () => { isNoMenuListViewOpen = false; }, selectedMenu: inputDatModel.selectedNoMenu }),
          // "class": "cui-dialog-xxl"
        }),
        m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed }),
        this.getBaseViews()
      ];
    }
  }
}
